import ContentMobileLayout from "@contents/mobile/layouts/contentLayout";
import {PageTitleType, SERVER_REF_TYPE} from "@app/constants/types";
import {Strings} from "@app/constants/strings";
import React, {useEffect} from "react";
import {PageBaseModel} from "@contents/models/baseModel";
import {DashboardViewModel} from "@contents/viewModels/dashboardViewModel";
import {Grid} from "@mui/material";
import BackgroundCardMobileComp from "@contents/mobile/layoutPages/components/BackgroundCardComp";
import {FlexBox} from "@contents/components/customStyledComponent";
import LabelSimpleMobileComp from "@contents/mobile/layoutPages/components/LabelSimpleComp";


const BrandDashboardShopOperationStateMobilePage = ({menuId}: PageBaseModel) => {
    const dashboardViewModel = DashboardViewModel();

    useEffect(() => {
        dashboardViewModel?.getBrandUsageShopDashboard();
    }, []);

    const shopData = dashboardViewModel?.brandUsageShopData?.map((shop) => {
        return {
            'shopName': shop.shopName?.ko,
            'shopType': shop.shopType === 'CAFE' ? '사내카페' : '사내식당',
            'actionRefType': SERVER_REF_TYPE[shop.actionRefType!],
            'companyCount': shop.companyCount ?? 0,
            'orderCount': shop.shopType === 'CAFE' ? (shop.orderCount?.toLocaleString() ?? 0) : (shop.cafeteriaOrderCount?.toLocaleString() ?? 0),
            'salesPrice': shop.shopType === 'CAFE' ? (shop.salesPrice?.toLocaleString() ?? 0) : (shop.cafeteriaSalesPrice?.toLocaleString() ?? 0)
        }
    }) ?? [];

    return (
        <ContentMobileLayout
            menuId={menuId}
            titleType={PageTitleType.TITLE}
            title={Strings.shopOperationStatus}
        >
            <Grid container spacing={1}>
                {shopData.length > 0 && shopData.map((item, index) => (
                    <Grid key={index} item xs={6}>
                        <BackgroundCardMobileComp title={item.shopName}>
                            <FlexBox $column gap={'10px'}>
                                <LabelSimpleMobileComp label={'Shop 유형'}>{item.shopType}</LabelSimpleMobileComp>
                                <LabelSimpleMobileComp label={'운영상태'}>{item.actionRefType}</LabelSimpleMobileComp>
                                <LabelSimpleMobileComp label={'사용법인'}>{item.companyCount}</LabelSimpleMobileComp>
                                <LabelSimpleMobileComp label={'주문건'}>{item.orderCount}</LabelSimpleMobileComp>
                                <LabelSimpleMobileComp label={'매출액'}>{item.salesPrice}</LabelSimpleMobileComp>
                            </FlexBox>
                        </BackgroundCardMobileComp>
                    </Grid>
                ))}
            </Grid>
        </ContentMobileLayout>
    )
}

export default BrandDashboardShopOperationStateMobilePage;